import React from 'react'
import PropTypes from 'prop-types'
import SaveImg from 'src/assets/img/house/btn_save.png'
import UnsaveImg from 'src/assets/img/house/btn_unsave.png'

export const HouseLayoutControls = ({ onSaveAndReturn, onReturnWithoutSave, isDisabledSave }) => {
  return (
    <div className="absolute top-3 left-3 flex gap-2 z-40">
      <button
        onClick={onSaveAndReturn}
        disabled={isDisabledSave}
        className="hover:scale-105 transition-transform disabled:transform-none disabled:scale-0"
      >
        <img src={SaveImg} alt="Save" className="h-10 w-auto" />
      </button>
      <button onClick={onReturnWithoutSave} className="hover:scale-105 transition-transform">
        <img src={UnsaveImg} alt="Unsave" className="h-10 w-auto" />
      </button>
    </div>
  )
}

HouseLayoutControls.propTypes = {
  onSaveAndReturn: PropTypes.func.isRequired,
  onReturnWithoutSave: PropTypes.func.isRequired,
  isDisabledSave: PropTypes.bool
}
